export default {"src":"/_next/static/media/doorIcon.34871b90.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};